import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useTranslation } from '@frontend/i18n';
import { Button, SpinningLoader, useModalControl } from '@frontend/design-system';
import { AddEditAppointmentTypeModal } from './add-edit-appointment-type-modal';

type NewAppointmentTypeButtonProps = {
  locationId: string;
};

export const NewAppointmentTypeButton = ({ locationId }: NewAppointmentTypeButtonProps) => {
  const { t } = useTranslation('schedule-settings');

  const { modalProps: createModalProps, triggerProps: createModalTriggerProps } = useModalControl();

  const { hasWSM, isLoading: isLoadingIntegrationDetails } = SchedulerV3.Helpers.useCheckHasWSM(locationId);

  if (isLoadingIntegrationDetails) return <SpinningLoader />;

  if (!locationId || !hasWSM) return null;

  return (
    <>
      <Button {...createModalTriggerProps} size='large'>
        {t('New Appointment Type')}
      </Button>
      <AddEditAppointmentTypeModal locationId={locationId} {...createModalProps} />
    </>
  );
};
